import { fork } from 'redux-saga/effects';
import commonSagas from 'modules/labs/common/sagas';
import accountManagementSagas from 'modules/labs/accountManagement/sagas';
import laboratoriesSagas from 'modules/labs/laboratories/sagas';
import ordersSagas from 'modules/labs/orders/sagas';
import masterListSagas from 'modules/labs/masterList/sagas';

export default function* rootSaga() {
  yield fork(commonSagas);
  yield fork(accountManagementSagas);
  yield fork(laboratoriesSagas);
  yield fork(ordersSagas);
  yield fork(masterListSagas);
}
